import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { REACT_APP_ENV } from '../../constants/configuration';

const CanonicalLink = () => {
  const location = useLocation();

  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      {REACT_APP_ENV === 'production' ? (
        <meta
          name="google-site-verification"
          content="OPK9wIXdgdPw1TeMo_WSZY9n-gzhbkImgMoMyj0Vx-E"
        />
      ) : null}
    </Helmet>
  );
};

export default CanonicalLink;
